const $ = require('jquery'),
	Backbone = require('backbone');

var FacetGroupExpandStatus = Backbone.Model.extend({
	urlRoot: '/app/api/search/setFacetGroupExpandStatus',
	initialize: function() {
		this.resetGroupStatuses();
	},
	addGroup: function(groupInfo) {
		let currentGroups = this.get('groupStatuses');

		currentGroups.push(groupInfo);

		this.set('groupStatuses', currentGroups);
	},
	resetGroupStatuses: function() {
		this.set('groupStatuses', []);
	},
	save: function() {
		return $.ajax({
			url: this.url(),
			method: 'POST',
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			data: JSON.stringify(this.get('groupStatuses'))
		}).then(this.resetGroupStatuses.bind(this));
	}
});

module.exports = FacetGroupExpandStatus;
